module.exports = __webpack_public_path__ + "static/media/pic-ht12.c6ff0cc3.jpg";